

import React, { memo, useState } from 'react';
import './_status-bar.scss';

function StatusBar({ balance, total }) {
  const [rendered, setRendered] = useState(false);

  if (!rendered) {
    setTimeout(() => {setRendered(true);});
  }

  const result = balance / total;
  const width = Number.isNaN(Number(result)) ? 0 : `${result * 100}%`;

  return (
    <div className="credits-status-bar">
      <div className="credits-status-bar__bar">
        <div className="credits-status-bar__progress" style={{ width: !rendered ? 0 : width }} />
      </div>
    </div>);

}

export default memo(StatusBar);